import { render, staticRenderFns } from "./AreaPlantadaBunge2026.vue?vue&type=template&id=7cea75e0&lang=pug"
import script from "./AreaPlantadaBunge2026.vue?vue&type=script&lang=js"
export * from "./AreaPlantadaBunge2026.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports